var map = {
	"./icon-01.png": "5aa8",
	"./icon-02.png": "c41b",
	"./icon-03.png": "cdb9",
	"./icon-04.png": "3c7c",
	"./icon-05.png": "1fce",
	"./icon-06.png": "11a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cae4";